// eslint-disable-next-line no-restricted-imports
import { AdminFragment } from 'api/generated/graphql';
import { AdminEntity } from 'api/types/entity';

import { parseUserRoleEntity } from '../parseEntity';

import { parseAdminStatus } from './parseAdminStatus';

export const parseAdminEntity = (user: AdminFragment): AdminEntity => ({
  id: user.id,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  middleName: user.middleName ?? undefined,
  status: parseAdminStatus(user.status),
  position: user.position ?? undefined,
  role: user.role ? parseUserRoleEntity(user.role) : undefined,
  isActive: user.isActive,
  otpVerified: user.otp?.verified,
});
